import { render, staticRenderFns } from "./DialogShowOnboardingBV.vue?vue&type=template&id=174c4afe&"
import script from "./DialogShowOnboardingBV.vue?vue&type=script&lang=js&"
export * from "./DialogShowOnboardingBV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports